import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class PlanningDraftResourcesSettingsPanelComponent implements IController {

  settings: any;
  onSettingsChange: Function;

  constructor(private $mdPanel) {

  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const settingsRef = this.settings;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<planning-draft-resources-settings-panel-template ' +
        'panel-ref="ctrl.mdPanelRef" settings="ctrl.settings">' +
        '</planning-draft-resources-settings-panel-template>',
      controller: function () {
        this.settings = settingsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, reason, updatedSettings) => {

        if (_.isEqual(reason, 'Submit')) {
          this.onSubmit(updatedSettings);
        }

        if (_.isEqual(reason, 'Reset')) {
          this.onReset();
        }

        if (_.isEqual(reason, 'Cancel')) {
          this.onReset();
        }

        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(settingsConfig) {
    this.onSettingsChange({
      settings: settingsConfig
    })
  }

  onSubmit(settings) {
    this.onSettingsChange({settings: settings});
  }

  onReset() {
    // const settingsConfig = this.splitService.getSiteAgentsSettings(this.splitService.getSiteId());
    // this.onSettingsChange({settings: settingsConfig});
  }

  onCancel() {
    this.onSettingsChange({settings: this.settings});
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningDraftResourcesSettingsPanel', {
    bindings: {
      settings: '<',
      onSettingsChange: '&'
    },
    template: require('./planning-draft-resources-settings-panel.html').default,
    controller: PlanningDraftResourcesSettingsPanelComponent
  });
